'use client';

import clsx from 'clsx';
import { Eye, EyeOff } from 'lucide-react';
import { InputHTMLAttributes, RefCallback, RefObject, useState } from 'react';
import { FieldError } from 'react-hook-form';

interface PasswordInputProps extends InputHTMLAttributes<HTMLInputElement> {
  ref?: RefObject<HTMLInputElement | null> | RefCallback<HTMLInputElement | null>;
  label?: string;
  error?: FieldError;
}

export function PasswordInput({
  ref,
  label,
  placeholder,
  error,
  ...restProps
}: PasswordInputProps) {
  const [showPassword, setShowPassword] = useState(false);
  const disableShowPassword = process.env.NEXT_PUBLIC_PASSWORD_SHOW_DISABLED === 'true';

  return (
    <fieldset className="fieldset relative">
      {label && (
        <legend className="fieldset-legend flex-wrap items-baseline justify-start gap-x-3 gap-y-0">
          {label}
          {restProps.required && '*'}
          {error && (
            <span className="validator-hint text-error mt-0">{error?.message?.toString()}</span>
          )}
        </legend>
      )}
      <label className={clsx('input w-full', error && 'input-error')}>
        <input
          ref={ref}
          type={showPassword ? 'text' : 'password'}
          placeholder={placeholder}
          className="grow"
          {...restProps}
        />
        {!disableShowPassword && (
          <button
            type="button"
            className={clsx('cursor-pointer', error ? 'text-error' : 'text-gray-400')}
            onClick={() => setShowPassword((prev) => !prev)}
          >
            {showPassword ? <Eye /> : <EyeOff />}
          </button>
        )}
      </label>
    </fieldset>
  );
}
